import React, { useEffect } from 'react';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { useSelector, useDispatch } from 'react-redux';
import {
  // BsNodePlus as EdgePosIcon,
  // BsNodeMinus as EdgeNegIcon,
  BsTrash as DeleteIcon,
} from 'react-icons/bs';
import {
  PiNumberCircleOne as NewNodeIcon,
  PiCursor as SelectIcon,
  // PiMapPinSimpleBold as EdgeNegIcon,
} from 'react-icons/pi';
import { RxSewingPinFilled as EdgeNegIcon } from 'react-icons/rx';
// import { MdArrowRightAlt as EdgePosIcon } from 'react-icons/md';
// import { MdOutlineArrowRightAlt as EdgePosIcon } from 'react-icons/md';
import { HiMiniArrowLongRight as EdgePosIcon } from 'react-icons/hi2';
// import { FaLongArrowAltRight as EdgePosIcon } from 'react-icons/fa';
// import { CgArrowLongRight as EdgePosIcon } from 'react-icons/cg';
import { setTool } from '../../features/toolbarSlice';

export default function Handler() {
  const tool = useSelector((state) => state.toolbar.tool);
  const dispatch = useDispatch();

  useEffect(() => {
    const handleKeyDown = (event) => {
      // prevent triggering when typing
      const { activeElement } = document;
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(activeElement.tagName)
        || activeElement.isContentEditable
      ) return;

      if (event.key === 'n') {
        dispatch(setTool('newNode'));
      }
      if (event.key === '+' || event.key === '=') {
        dispatch(setTool('edgePos'));
      }
      if (event.key === '-') {
        dispatch(setTool('edgeNeg'));
      }
      if (event.key === 'd') {
        dispatch(setTool('delete'));
      }
      if (event.key === 's') {
        dispatch(setTool('select'));
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });

  return (
    <ToggleButtonGroup
      size="small"
      value={tool}
      onChange={(event, data) => dispatch(setTool(data))}
      exclusive
    >
      <ToggleButton value="newNode" title="Node [n]">
        <NewNodeIcon size="1.5em" />
      </ToggleButton>
      <ToggleButton value="edgePos" title="Link (positive) [+]">
        <EdgePosIcon size="1.5em" style={{ fontSize: '16px' }} />
      </ToggleButton>
      <ToggleButton value="edgeNeg" title="Link (negative) [-]">
        <EdgeNegIcon size="1.5em" style={{ transform: 'rotate(90deg)', fontSize: '16px' }} />
      </ToggleButton>
      <ToggleButton value="delete" title="Delete [d]">
        <DeleteIcon size="1.5em" />
      </ToggleButton>
      <ToggleButton value="select" title="Select [s]">
        <SelectIcon size="1.5em" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
